import { IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CollapseButton = ({ onClick, sx }) => {
  return (
    <IconButton
      sx={{ paddingBlock: 0, ...sx }}
      color="primary"
      size="small"
      onClick={onClick}
    >
      <ExpandLessIcon fontSize="large" />
    </IconButton>
  );
};

export default CollapseButton;
